import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { makeStyles } from "@material-ui/core/styles";
import { map, find } from "lodash";

import SelectedList from "../../Components/List/SelectedList";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import {
  getTaskInfo,
  getTaskAssets,
  createSelectedAssetsArray,
  createTask,
  updateTask,
} from "./Services";
import { validator } from "../../Js/Validator";
import { durationCalculate, userLogs, getAsset } from "../../Js/Common";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import Confirmation from "../../Components/Modal/Confirmation";

const TaskDetail = (props) => {
  // Hooks
  const classes = useStyles();
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id, type } = useParams();

  // State
  const [valid, setValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [taskData, setTaskData] = useState(null);
  const [createdUpdatedData, setCreatedUpdatedData] = useState(null);
  const [assetInfo, setAssetInfo] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const productId = useSelector(
    (state) => state.defs.siteConfig.products[0]["productId"]
  );
  const {
    selectedAssets,
    duration,
    taskName,
    description,
    tags,
    mode,
    taskId,
    durationStartTimeStamp,
  } = useSelector((state) => state.task);
  const { siteConfig } = useSelector((state) => state.defs);

  // React logic hooks
  useEffect(() => {
    if (location.pathname.includes("Create")) {
      dispatch(taskSliceActions.setMode("create"));
      dispatch(taskSliceActions.setTaskId(null));
      setValid(false);
    }
    if (location.pathname.includes("Edit")) {
      dispatch(taskSliceActions.setMode("edit"));
      setValid(true);
    }
  }, []);

  useEffect(() => {
    if (selectedAssets && selectedAssets.length > 0) {
      getAssetData(map(selectedAssets, "id"));
    }
  }, [selectedAssets]);

  useEffect(() => {
    if (mode == "edit" && taskId == null) {
      fetchTaskInfo();
    }
    if (mode == "edit") {
      dispatch(taskSliceActions.startDuration());
    }
  }, [mode]);

  useEffect(() => {
    console.log("taskData", taskData);
    if (taskData) {
      dispatch(taskSliceActions.setTaskName(taskData.title));
      dispatch(taskSliceActions.setDescription(taskData.description));
      dispatch(taskSliceActions.setTags(taskData.tags.tags.join(",")));
      dispatch(taskSliceActions.setTaskId(taskData.uid));
    }
  }, [taskData]);

  useEffect(() => {
    dispatch(taskSliceActions.setDurationFlag(true));
  }, []);

  // Fetch Task Information
  const fetchTaskInfo = async () => {
    let taskInfoData = await getTaskInfo(id, userInfo.site_uuid);
    setTaskData(taskInfoData.data[0]);
    let assets = await getTaskAssets(
      taskInfoData.data[0].data1.exersices,
      userInfo.site_uuid
    );
    console.log("SDDDD", assets);
    dispatch(
      taskSliceActions.setAllSelectedAssets(
        createSelectedAssetsArray(assets.data)
      )
    );
  };

  // Validate taskname on blur
  const tasknameBlurValidate = () => {
    let validate = validator({
      required: true,
      value: taskName ? taskName.trim() : taskName,
    });
    if (!validate["validate"]) {
      setErrorMessage(validate["message"]);
      setValid(false);
    } else {
      setErrorMessage(null);
      setValid(true);
    }
  };

  // Save task
  const saveTask = async () => {
    tasknameBlurValidate();
    if (valid) {
      let dataObj = {
        created_by: userInfo.uid,
        title: taskName,
        tags: { tags: tags.split(",") },
        data1: {
          exersices: selectedAssets.map((val) => {
            return val.id;
          }),
          evaluationExe: [],
          exeInfo: assetInfo,
        },
        estimated_time: selectedAssets.reduce((total, val) => {
          return total + Number(val.duration);
        }, 0),
        description: description,
        site_uuid: userInfo.site_uuid,
        tasktype: type,
        product_uid: productId,
      };

      let logObj = {
        actor: userInfo.uid,
        verb: "task",
        outcome: {
          duration: durationCalculate(duration, durationStartTimeStamp),
        },
        site_uuid: userInfo.site_uuid,
      };

      let response;
      console.log(":::", taskData);
      if (mode == "create") {
        console.log(":::1111");
        response = await createTask(dataObj);
        setCreatedUpdatedData(response.data);
        logObj["outcome"]["action"] = "create";
        logObj["target"] = response.data.uid;
        logObj["outcome"]["value"] = response.data.data1;
      }
      if (mode == "edit") {
        console.log(":::222");
        response = await updateTask(dataObj, id, userInfo.site_uuid);
        console.log("response", response);
        setCreatedUpdatedData(response.data[0]);
        logObj["outcome"]["action"] = "edit";
        logObj["target"] = taskId;
        logObj["outcome"]["value"] = {
          exersices: map(selectedAssets, "id"),
          evaluationExe: [],
        };
      }

      if (response.status == 200) {
        let logResponse = await userLogs(logObj);
        setConfirmModal(true);
        resetState();
      }
    }
  };

  // Reset all states on successful login
  const resetState = () => {
    dispatch(taskSliceActions.resetState());
    setErrorMessage(null);
    setValid(true);
  };

  // Action for Yes & No after task save
  const yesOrNo = (flag) => {
    if (flag === "yes") {
      setConfirmModal(false);
      if (createdUpdatedData.tasktype.toUpperCase() == "ASSETS") {
        dispatch(
          assignmentSliceActions.addTask({
            id: createdUpdatedData.uid,
            name: createdUpdatedData.title,
            estimated_time: createdUpdatedData.estimated_time,
            assets: createdUpdatedData.data1.exersices,
          })
        );
        navigation("/Assign/Create/assets");
      }
      if (createdUpdatedData.tasktype.toUpperCase() == "MEDIA") {
        dispatch(
          assignmentSliceActions.addTask({
            id: createdUpdatedData.uid,
            name: createdUpdatedData.title,
            estimated_time: createdUpdatedData.estimated_time,
          })
        );
        dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
        navigation("/Assign/Create/media");
      }
      if (createdUpdatedData.tasktype.toUpperCase() == "LIBRARY") {
        dispatch(
          assignmentSliceActions.addTask({
            id: createdUpdatedData.uid,
            name: createdUpdatedData.title,
            estimated_time: createdUpdatedData.estimated_time,
            assets: createdUpdatedData.data1.exersices,
          })
        );
        dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
        navigation("/Assign/Create/library");
      }
    } else {
      setConfirmModal(false);
      navigation("/Task");
    }
  };

  const addMore = () => {
    if (mode == "create") {
      if (type == "assets") {
        navigation("/Task/Create");
      } else {
        navigation("/Task/Create/LibraryTask");
      }
    }
    if (mode == "edit") {
      if (type == "assets") {
        navigation("/Task/Edit");
      } else {
        navigation("/Task/Edit/LibraryTask");
      }
    }
  };

  let getAssetData = async (assetIds) => {
    let assetData = await getAsset({
      $in: assetIds,
    });
    console.log("assetData", assetData);
    let assetInfo = selectedAssets.map((val, ind) => {
      let foundObj = find(assetData.data, { asset_uid: val.id });
      let jsondata =
        typeof foundObj.content == "string"
          ? JSON.parse(foundObj.content)
          : foundObj.content;
      return {
        asset_id: foundObj.asset_uid,
        skills: jsondata.content.info.skills,
        asset_type: jsondata.content.info.asset_type_alias,
        difficulty: jsondata.content.info.difficulty_level,
        cefr_level: "",
      };
    });
    setAssetInfo(assetInfo);
  };

  const goToView = (id) => {
    navigation(`/Task/AssetView/${id}`);
  };

  return (
    <Grid container sx={{ gap: 2 }}>
      <Grid item xs={5} sx={{ pl: 1, mt: 5 }}>
        <Box sx={{ boxShadow: 3, borderRadius: 5 }}>
          <Grid
             
            sx={{ height: "68vh", overflow: "auto", py: 3, px: 2 }}
          >
            {selectedAssets && selectedAssets.length == 0 && (
              <Box sx={{ textAlign: "center" }}>
                {/* <img src={require('../../assets/Assign_place.png')} width="50%" /> */}
                <Typography
                  sx={{ color: "#A9A9A9", fontWeight: 600, fontSize: "0.9rem" }}
                >
                  This is where you'll see all your added assets
                </Typography>
              </Box>
            )}

            <Box
              sx={{ height: "53vh", overflowY: "auto" }}
               
            >
              {selectedAssets &&
                selectedAssets.length > 0 &&
                selectedAssets.map((val, index) => {
                  return (
                    <div key={`${index}_selectedAssets`}>
                      <SelectedList
                        data={{
                          name: `${index + 1}. ${
                            val.name.includes(".")
                              ? val.name.split(".")[1]?.trim()
                              : val.name
                          }`,
                          id: val.id,
                        }}
                        viewaction={true}
                        view={() => {
                          goToView(val.id);
                        }}
                      ></SelectedList>
                    </div>
                  );
                })}
            </Box>

            <Button
              variant="contained"
              size="small"
              sx={{
                px: 5,
                ml: 3,
                mt: 2,
                borderRadius: 15,
                backgroundColor: "primary.main",
                color: "#FFFFFF",
                height: "2rem",
                textTransform: "inherit",
               
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                  height: "3rem",
                },
              }}
              onClick={addMore}
            >
              {type && type == "assets" ? "Add More" : "Change Book"}
            </Button>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={6} sx={{ mt: 5 }}>
        <Box sx={{ height: "53vh", overflowY: "auto", pb: 5 }}>
          <Box sx={{}}>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "500",
                fontSize: "0.9rem",
                pl: 2,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
            >
              Task Name:
            </Typography>
            <TextField
              id="filled-basic"
              error={errorMessage}
              fullWidth
              size="small"
              placeholder="Enter name"
              sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
              InputProps={{
                inputProps: {
                  sx: {
                    fontSize: "0.8rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  },
                },
                style: { borderRadius: 50 },
              }}
              helperText={errorMessage}
              onBlur={tasknameBlurValidate}
              onInput={(event) => {
                dispatch(taskSliceActions.setTaskName(event.target.value));
              }}
              value={taskName}
            />
          </Box>
          <Box sx={{ mt: 6 }}>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "500",
                fontSize: "0.9rem",
                pl: 2,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
            >
              Description:
            </Typography>
            <TextField
              id="filled-basic"
              fullWidth
              size="small"
              placeholder="Enter Description"
              sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
              InputProps={{
                inputProps: {
                  sx: {
                    fontSize: "0.8rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  },
                },
                style: { borderRadius: 50 },
              }}
              onInput={(event) => {
                dispatch(taskSliceActions.setDescription(event.target.value));
              }}
              value={description}
            />
          </Box>
          {siteConfig.customer?.addOnInfo?.isSelfLearning && (
            <Box sx={{ mt: 6 }}>
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  pl: 2,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                Tag:
              </Typography>
              <TextField
                id="filled-basic"
                fullWidth
                size="small"
                placeholder="Add Tags"
                sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
                InputProps={{
                  inputProps: {
                    sx: {
                      fontSize: "0.8rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    },
                  },
                  style: { borderRadius: 50 },
                }}
                onInput={(event) => {
                  dispatch(taskSliceActions.setTags(event.target.value));
                }}
                value={tags}
              />
            </Box>
          )}
        </Box>
        {selectedAssets && selectedAssets.length > 0 && (
          <Button
            variant="contained"
            size="small"
            sx={{
              px: 5,
              borderRadius: 15,
              backgroundColor: "primary.main",
              color: "#FFFFFF",
              height: "2rem",
              textTransform: "inherit",
             
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
                height: "3rem",
              },
            }}
            onClick={saveTask}
          >
            Save
          </Button>
        )}
        <Confirmation
          image="assign"
          primaryText="Task has been saved"
          secondaryText="Do you want to assign it to students?"
          visible={confirmModal}
          positiveClick={() => {
            yesOrNo("yes");
          }}
          negativeClick={() => {
            yesOrNo("no");
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
          persistent={true}
        ></Confirmation>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default TaskDetail;
